import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Modal from 'ui-library/modals/Modal';

export interface BulkRemoveFeaturesModalProps {
  feature: string;
  onRequestClose: () => void;
  onRequestSubmit: (arg: boolean) => void;
}

export default function BulkRemoveFeaturesModal({
  feature,
  onRequestClose,
  onRequestSubmit,
}: BulkRemoveFeaturesModalProps): JSX.Element {
  let titleText = 'Remove Features';
  let userMessage = 'Are you sure you want to remove all features from the selected sequences?';
  if (feature === 'primer') {
    titleText = 'Detach Primers';
    userMessage = 'Are you sure you want to detach all primers from the selected sequences?';
  } else if (feature === 'annotation') {
    titleText = 'Remove Annotations';
    userMessage = 'Are you sure you want to remove all annotations from the selected entities?';
  } else if (feature === 'translation') {
    titleText = 'Remove Translations';
    userMessage = 'Are you sure you want to remove all translations from the selected sequences?';
  }
  return (
    <Modal
      buttons={[
        {text: 'Cancel', cancel: true},
        {text: titleText, submit: true},
      ]}
      onRequestClose={onRequestClose}
      onRequestSubmit={() => {
        onRequestSubmit(true);
      }}
      title={titleText}
    >
      <div className={css(styles.section)}>{userMessage}</div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  section: {
    marginBottom: 5,
  },
});
